import { APIFetchError } from "@cur8/api-client";

export function isErrorOfCode(status: number, error: unknown) {
  return error instanceof APIFetchError && error.response.status === status;
}
